import Route from "../../../router/Route";
import { RouterView, RouteLocationNormalized } from "vue-router";

import Overview from "../pages/Overview.vue";
import ManageOverview from "../pages/Manage.vue";
import ActivityTab from "../components/ActivityTab.vue";
import Configuration from "../components/ConfigurationTab.vue";

export default new Route("integrations", "/integrations", RouterView, [
	new Route("integrations.index", "", Overview, []),
	new Route(
		"integrations.manage",
		"manage/:uuid",
		ManageOverview,
		[
			new Route("integrations.manage.activity", "activity", ActivityTab, []),
			new Route(
				"integrations.manage.configuration",
				"configuration",
				Configuration,
				[]
			),
		],
		{},
		(to: RouteLocationNormalized): string => {
			return `/integrations/manage/${to.params.uuid}/activity`;
		}
	),
]);
